import $ from 'jquery'
import { Modal } from 'bootstrap'

const menu = document.getElementById('menu-offcanvas')

if (menu) {
    const hamburger = document.querySelector('.hamburger')

    menu.addEventListener('show.bs.offcanvas', () => {
        document.body.classList.add('menu-active')
        hamburger.classList.add('is-active')
    })

    menu.addEventListener('hide.bs.offcanvas', () => {
        document.body.classList.remove('menu-active')
        hamburger.classList.remove('is-active')
    })
}
